<template>
  <v-container class="text-center">
    <v-row justify="center">
      <v-col cols="12" md="5">
        <base-material-card color="secondary" class="boxContainer" :title="$t('scan_info_user')"
          icon="mdi-qrcode-scan justify-center text-center">
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-btn class="mt-n2" elevation="1" :color="scanQR === 'myASD' ? 'error' : 'primary'"
                  @click="switchScan(scanQR === 'myASD' ? false : 'myASD')">
                  <v-icon style="margin-right: 10px">mdi-qrcode-scan</v-icon>
                  <span v-if="scanQR === 'myASD'">Stop</span>
                  <span v-else>MyASD</span>
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn class="mt-n2" elevation="1" :color="scanQR === 'greenpass' ? 'error' : 'success'" @click="
                  switchScan(scanQR === 'greenpass' ? false : 'greenpass')
                  ">
                  <v-icon style="margin-right: 10px">mdi-qrcode-scan</v-icon>
                  <span v-if="scanQR === 'greenpass'">Stop</span>
                  <span v-else>Greenpass</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
          <v-container v-if="scanQR">
            <v-row>
              <v-col cols="12">
                <qrcode-stream class="qrcodeScan" @decode="onDecode" />
              </v-col>
            </v-row>
          </v-container>
          <v-container v-else-if="infoUser">
            <v-row>
              <v-col cols="12">
                <v-tabs background-color="primary" center-active dark v-model="tab">
                  <v-tab v-if="infoUser.userData">{{ $t("info") }}</v-tab>
                  <v-tab v-if="infoUser.eventiAttivi">{{ $t("events") }}</v-tab>
                  <v-tab v-if="
                    infoUser.prodotti2evade &&
                    infoUser.prodotti2evade.length > 0
                  ">
                    <v-badge color="green" :content="infoUser.prodotti2evade.length">
                      {{ $t("products") }}
                    </v-badge>
                  </v-tab>
                  <v-tab v-if="infoUser.greenpassData">GREENPASS</v-tab>
                  <v-tab v-if="infoUser.certificato">{{
                    $t("certificate")
                    }}</v-tab>
                  <v-tab v-if="infoUser.tessereOwned">{{ $t("cards") }}</v-tab>
                </v-tabs>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-tabs-items v-model="tab" class="infoContainer">
                  <v-tab-item v-if="infoUser.userData">
                    <v-simple-table>
                      <tbody>
                        <tr>
                          <td colspan="2">
                            <div class="text-center" style="font-weight: bold; font-size: 18px">
                              {{ infoUser.userData.name }}
                              {{ infoUser.userData.surname }}
                            </div>
                            <img style="width: 150px; heigth: 150px" class="img" :src="infoUser.userData.foto" />
                          </td>
                        </tr>

                        <tr v-if="infoUser.greenpassData">
                          <td class="text-left">{{ $t("greenpass") }}</td>
                          <td class="text-right">
                            {{
                              infoUser.greenpassData.current
                                ? infoUser.greenpassData.current.type
                                : ""
                            }}
                            &nbsp;
                            {{
                              infoUser.greenpassData.current
                                ? new Date(
                                  infoUser.greenpassData.current.dateInz
                                ).toLocaleDateString() + "&nbsp; - &nbsp;"
                                : ""
                            }}
                            {{
                              infoUser.greenpassData.current
                                ? new Date(
                                  infoUser.greenpassData.current.dateEnd
                                ).toLocaleDateString()
                                : ""
                            }}
                            <v-icon large :color="infoUser.greenpassData.valid
                                ? 'success'
                                : 'error'
                              ">
                              {{
                                infoUser.greenpassData.valid
                                  ? "mdi-check-circle"
                                  : "mdi-close-circle"
                              }}
                            </v-icon>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-left">{{ $t("certificate") }}</td>
                          <td class="text-right">
                            {{
                              infoUser.certificato
                                ? new Date(
                                  infoUser.certificato.dateInz
                                ).toLocaleDateString() + "&nbsp; - &nbsp;"
                                : ""
                            }}

                            {{
                              infoUser.certificato
                                ? new Date(
                                  infoUser.certificato.dateEnd
                                ).toLocaleDateString()
                                : ""
                            }}
                            <v-icon large :color="infoUser.certificato ? 'success' : 'error'
                              ">
                              {{
                                infoUser.certificato
                                  ? "mdi-check-circle"
                                  : "mdi-close-circle"
                              }}
                            </v-icon>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-left">{{ $t("card") }}</td>
                          <td class="text-right" v-if="infoUser.tesseraAttiva">
                            {{ infoUser.tesseraAttiva.asdRagSoc }}
                            <span :style="'color:' + infoUser.tesseraAttiva.hexColor + ';'
                              ">
                              {{ infoUser.tesseraAttiva.nome }} -
                              {{ infoUser.tesseraAttiva.asdTesNum }}</span>
                            <v-icon large color="success">
                              mdi-check-circle
                            </v-icon>
                          </td>
                          <td class="text-right" v-else>
                            <v-icon large color="error">
                              mdi-close-circle
                            </v-icon>
                          </td>
                        </tr>

                        <tr>
                          <td class="text-left">{{ $t("telephone") }}</td>
                          <td class="text-right">
                            {{ infoUser.userData.tel }}
                          </td>
                        </tr>
                        <tr>
                          <td class="text-left">{{ $t("residence_city") }}</td>
                          <td class="text-right">
                            {{ infoUser.userData.resCity }}
                          </td>
                        </tr>
                        <tr>
                          <td class="text-left">{{ $t("birth_date") }}</td>
                          <td class="text-right">
                            {{
                              new Date(
                                infoUser.userData.birthDate
                              ).toLocaleDateString()
                            }}
                            ({{ getEta(infoUser.userData.birthDate) }})
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-tab-item>
                  <v-tab-item v-if="infoUser.eventiAttivi">
                    <v-simple-table v-for="evento in infoUser.eventiAttivi" v-bind:key="evento.id">
                      <thead>
                        <tr>
                          <th colspan="3" class="text-center">
                            {{ evento.titolo }} -
                            {{ new Date(evento.dateInz).toLocaleDateString() }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="pacchetto in evento.pacchetti" v-bind:key="pacchetto.pacchetto">
                          <td>
                            <v-icon large color="success">
                              mdi-check-circle
                            </v-icon>
                          </td>
                          <td>{{ pacchetto.dettaglio }}</td>
                          <td>{{ pacchetto.opzioni }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-tab-item>
                  <v-tab-item v-if="
                    infoUser.prodotti2evade &&
                    infoUser.prodotti2evade.length > 0
                  ">
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th>
                            {{ $t("order_number") }}
                          </th>
                          <th>
                            {{ $t("product") }}
                          </th>
                          <th>
                            {{ $t("options") }}
                          </th>
                          <th>
                            {{ $t("quantity") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="prodotto in infoUser.prodotti2evade" v-bind:key="prodotto.full_id">
                          <td class="text-left">
                            {{ prodotto.orderId }}<br />{{
                              new Date(prodotto.data).toLocaleDateString()
                            }}
                          </td>

                          <td class="text-left">{{ prodotto.prodotto }}</td>
                          <td class="text-left" v-html="prodotto.opzioni.join('<br>')"></td>
                          <td>
                            {{ prodotto.qtaCon + "/" + prodotto.qtaRic }}
                            <v-tooltip top v-if="RBAC_EVADE">
                              <template v-slot:activator="{ on }">
                                <v-btn @click="
                                  evadeOrder(
                                    prodotto.orderId,
                                    prodotto.riga,
                                    prodotto.qtaRic
                                  )
                                  " color="success" icon>
                                  <v-icon>mdi-cart-arrow-up</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("evade_order_line") }}</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-tab-item>
                  <v-tab-item v-if="infoUser.greenpassData">
                    <v-simple-table>
                      <tbody>
                        <tr>
                          <td class="text-left">{{ $t("greenpass") }}</td>
                          <td class="text-right">
                            {{
                              infoUser.greenpassData.current
                                ? infoUser.greenpassData.current.type
                                : ""
                            }}
                            &nbsp;
                            {{
                              infoUser.greenpassData.current
                                ? new Date(
                                  infoUser.greenpassData.current.dateInz
                                ).toLocaleDateString()
                                : ""
                            }}
                            &nbsp; - &nbsp;
                            {{
                              infoUser.greenpassData.current
                                ? new Date(
                                  infoUser.greenpassData.current.dateEnd
                                ).toLocaleDateString()
                                : ""
                            }}
                            <v-icon large :color="infoUser.greenpassData.valid
                                ? 'success'
                                : 'error'
                              ">
                              {{
                                infoUser.greenpassData.valid
                                  ? "mdi-check-circle"
                                  : "mdi-close-circle"
                              }}
                            </v-icon>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-left">{{ $t("name") }}</td>
                          <td class="text-right">
                            {{ infoUser.greenpassData.name }}
                          </td>
                        </tr>

                        <tr>
                          <td class="text-left">{{ $t("surname") }}</td>
                          <td class="text-right">
                            {{ infoUser.greenpassData.surname }}
                          </td>
                        </tr>
                        <tr>
                          <td class="text-left">birthDate</td>
                          <td class="text-right">
                            {{ infoUser.greenpassData.birthDate }}
                          </td>
                        </tr>
                        <tr>
                          <td class="text-left">version</td>
                          <td class="text-right">
                            {{ infoUser.greenpassData.version }}
                          </td>
                        </tr>
                        <tr v-for="(value, name) in infoUser.greenpassData
                          .current" v-bind:key="name">
                          <td class="text-left">{{ name }}</td>
                          <td class="text-right">{{ value }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-tab-item>
                  <v-tab-item v-if="infoUser.certificato">
                    <img :src="authorizeLink(infoUser.certificato.url)" />
                  </v-tab-item>
                  <v-tab-item v-if="infoUser.tessereOwned">
                    <v-simple-table>
                      <tbody>
                        <tr v-for="tessera in infoUser.tessereOwned" v-bind:key="tessera.full_key">
                          <td>{{ tessera.tesAnno }}</td>
                          <td>{{ tessera.asdRagSoc }}</td>
                          <td>
                            <b :style="'color:' + tessera.hexColor + ';'">
                              {{ tessera.nome }}</b>
                          </td>
                          <td>
                            <b :style="'color:' + tessera.hexColor + ';'">
                              {{ tessera.numero }}</b>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-container>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Swal from "sweetalert2";
import { QrcodeStream } from "vue-qrcode-reader";
export default {
  name: "get-qr-info-user",
  components: {
    QrcodeStream,
  },
  data() {
    return {
      infoUser: null,
      scanQR: false,
      tab: 1,
      params: null,
      RBAC_EVADE: false,
    };
  },
  mounted() {
    this.RBAC_EVADE = this.checkUserRole("order", "EVADE");
  },
  methods: {
    getEta: function (date) {
      let eta = null;
      let birthday = new Date(date);
      if (birthday !== "Invalid Date") {
        var ageDifMs = Date.now() - birthday.getTime();
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        eta = Math.abs(ageDate.getUTCFullYear() - 1970);
      }
      return eta;
    },
    evadeOrder(orderId, riga, qtaRic) {
      const _ = this;

      Swal.fire({
        title: this.$t("evade_order_line"),
        type: "warning",
        html: this.$t("you_cant_revert_this"),
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.chiamataAxios("POST", "/auth/portal/setOrderEvaso/" + orderId, {
            body: {
              updLine: [{ riga: riga, qtaCon: qtaRic }],
            },
          }).then((response) => {
            if (response.msg.esito) _.loadData();
          });
        }
      });
    },
    switchScan(mode) {
      this.scanQR = mode;
      this.infoUser = null;
    },
    loadData() {
      let _ = this;
      _.tab = 1;
      if (this.params.mode) {
        //console.dir(_.params);
        _.chiamataAxios("POST", "/auth/portal/getUserByQR", {
          body: _.params,
        }).then((response) => {
          _.infoUser = response.data;
          _.scanQR = false;
        });
      } else {
        _.scanQR = false;
        _.infoUser = false;
      }
    },
    onDecode(decodedString) {
      let _ = this;
      _.params = { mode: null };
      if (this.scanQR && this.scanQR === "myASD") {
        try {
          const url = new URL(decodedString);
          let qrBuffer = url.searchParams.get("qr");
          let infoUser = JSON.parse(atob(qrBuffer));
          // let infoUser = decodedString.replace(/^"(.+(?="$))"$/, "$1");
          // infoUser = JSON.parse(infoUser);
          _.params.mode = "myASD";
          _.params.masterId = infoUser.masterId;
          _.params.email = infoUser.email;
        } catch (e) { }
      }
      if (this.scanQR && this.scanQR === "greenpass") {
        _.params.mode = "greenpass";
        _.params.greenpass = decodedString;
      }
      _.loadData();
    },
  },
};
</script>
<style scoped>
.boxContainer {
  height: 760px;
}

.infoContainer {
  height: 500px;
  overflow: auto;
}
</style>